import axiosInstance from "../Common/Axios/axiosInstance";
import API from "../Common/Endpoint/serviceConstrants";

export const callActiveCardPostApi = async (payload) => {
  // Balance lookup only: this must not change the member's active account.
  const serverPayload = { ...(payload || {}), isAccountSwitch: false };
  const { data = [] } = await axiosInstance.post(API.switch_AccountApi, serverPayload);
  return data;
};
